module.exports = __webpack_public_path__ + "overview-a5b6df21/mapIcon-bcfaa1f03e9f672f90174d3a81ba8f12.svg";